import { Injectable } from '@angular/core';
import { StorageServiceProvider } from '../storage-service/storage-service';
import { Observable, ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT } from '../../../../../environments/environment';

@Injectable()
export class TenantService {
  private readonly storageKey = 'tenant';
  private currentTenant: string;
  private tenantSubject = new ReplaySubject<string>();

  constructor(private http: HttpClient, private storageService: StorageServiceProvider) {
    this.tryGetTenantFromStorage();
  }

  private tryGetTenantFromStorage(): void {
    this.storageService
      .get(this.storageKey)
      .then((tenant: string) => this.setTenantAndEmit(tenant, true))
      .catch((error) => console.log('[TenantService] Cannot get tenant from storage', error));
  }

  public setTenant(tenant: string): Promise<void> {
    return this.checkTenant(tenant).then(() => this.setTenantAndEmit(tenant));
  }

  private setTenantAndEmit(tenant: string, notStore?: boolean): Promise<void> {
    this.currentTenant = tenant;
    this.tenantSubject.next(tenant);

    return notStore ? Promise.resolve() : this.storageService.set(this.storageKey, tenant);
  }

  private checkTenant(tenant: string): Promise<IdentityProviderResponse> {
    return this.http.get<IdentityProviderResponse>(ENVIRONMENT.realmUrl.replace('{tenant}', tenant)).toPromise();
  }

  public getTenant(): string {
    if (!this.currentTenant) {
      throw new Error('[TenantService] A tenant has not been set');
    }
    return this.currentTenant;
  }

  public getTenantObservable(): Observable<string> {
    return this.tenantSubject;
  }

  public getPersonalAccountUrl(): string {
    return ENVIRONMENT.realmUrl.replace('{tenant}', this.currentTenant) + '/account/#/personal-info';
  }

  public getConsoleUrl(): string {
    return ENVIRONMENT.consoleUrl.replace('{tenant}', this.currentTenant);
  }
}

interface IdentityProviderResponse {
  realm: string;
  public_key: string;
  'token-service': string;
  'tokens-not-before': number;
  'account-service': string;
}



// WEBPACK FOOTER //
// ./src/modules/core/services/tenant-service/tenant.service.ts